import { mutatorAction } from 'satcheljs';
import SurfaceStore from '../interfaces/SurfaceStore';

export const addNewGridViewRef = mutatorAction('addNewGridViewRef', function addNewGridViewRef(
    element: HTMLElement,
    store: SurfaceStore
) {
    store.calendarDayListBounds.gridViewRefs.push({
        element: element,
        bounds: element.getBoundingClientRect(),
    });
});

export const addNewAllDayPanelViewRef = mutatorAction(
    'addNewAllDayPanelViewRef',
    function addNewAllDayPanelViewRef(element: HTMLElement, store: SurfaceStore) {
        store.calendarDayListBounds.allDayPanelViewRefs.push({
            element: element,
            bounds: element.getBoundingClientRect(),
        });
    }
);

export const addNewInDayScrollRef = mutatorAction(
    'addNewInDayScrollRef',
    function addNewInDayScrollRef(element: HTMLElement, store: SurfaceStore) {
        store.calendarDayListBounds.inDayScrollRef = {
            element: element,
            bounds: element.getBoundingClientRect(),
        };
    }
);

export const resetCalendarDayListBounds = mutatorAction(
    'resetCalendarDayListBounds',
    function resetCalendarDayListBounds(store: SurfaceStore) {
        store.calendarDayListBounds = {
            gridViewRefs: [],
            allDayPanelViewRefs: [],
            inDayScrollRef: null,
        };
    }
);
